import { palette } from "@dev/ee-components";
import styled from "styled-components";

type SearchInputWrapperType = {
    $isMobile: boolean;
};
export const SearchInputWrapper = styled.div<SearchInputWrapperType>`
    padding: ${(props): string => (props.$isMobile ? '24px 20px 0' : '24px 48px 0')};
`;

type ItemsGalleryItemsType = {
    $isMobile: boolean;
    $minItemWidth: string;
};

export const ItemsGalleryItems = styled.div<ItemsGalleryItemsType>`
    display: grid;
    grid-template-columns: ${(props): string => `repeat(auto-fill, minmax(${props.$minItemWidth}, 1fr))`};
    gap: 16px;
    padding: ${(props): string => (props.$isMobile ? '24px 20px 20px' : '60px 48px 20px')};
`;

export const ItemsGalleryItem = styled.div`
    width: 100%;
    aspectRatio: 4 / 5;
    overflow: hidden;
    border: 1px solid ${palette.gray[3]};
    border-radius: 4px;
    height: 100%;
    display: grid;
    grid-template-rows: minmax(307px, 1fr) minmax(min-content, 40px);

    &:hover: {
        background-color: rgba(45, 47, 122, 0.24);
    }
`;

export const ItemsGalleryScreenshot = styled.img`
    width: 100%;
    display: block;
`;

export const ItemsGalleryItemName = styled.div`
    width: 100%;
    border-top: 1px solid ${palette.gray[3]};
    padding: 12px 40px 12px 12px;
    background: ${palette.basic.paper};
    box-sizing: border-box;
    text-align: left;
    border-radius: 0 0 4px 4px;
    pointer-events: none;
    overflow: hidden;
    & div {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`;

export const ItemsGalleryButtons = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    padding: 0 4px;
    justify-content: center;
    align-content: center;
    opacity: 0;
    background-color: rgba(45, 47, 122, 0.24);

    > button {
        border-radius: 20px;
        width: 63px;

        &:hover {
            border: 1px solid ${palette.indigo[6]};
        }
    }
`;

export const ItemsGalleryButtonIcon = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: ${palette.indigo[6]};
    text-transform: none;
    & svg {
        fill: ${palette.indigo[6]};
    }
`;

export const ItemsGalleryScreenshotWrapper = styled.div`
    aspectRatio: 4 / 5;
    background-color: ${palette.gray[1]};
    position: relative;
    overflow: hidden;
    &:hover ${ItemsGalleryButtons} {
        opacity: 1;
    }
`;
